import {
  Component,
  OnDestroy,
  OnInit,
  afterNextRender,
  inject,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PublicService } from './core/services/public.service';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { FooterComponent } from './core/components/footer/footer.component';
import { Subscription } from 'rxjs';
import { UserService } from './users/user.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, NavbarComponent, FooterComponent],
})
export class AppComponent implements OnDestroy, OnInit {
  title = 'GAIF_Website';
  activeUrl: string = '';

  publicService = inject(PublicService);
  router = inject(Router);
  userService = inject(UserService);
  translateService = inject(TranslateService);
  subscriptions: Subscription = new Subscription();

  constructor() {
    afterNextRender(() => {
      let currentLanguage = this.publicService.getAppCurrentLanguage();
      this.publicService.updateBodyDirection(currentLanguage);
      this.translateService.setDefaultLang(currentLanguage);
      this.subscriptions.add(
        this.translateService.onDefaultLangChange.subscribe((res) => {
          this.publicService.updateBodyDirection(res.lang);
          if (res && res.lang !== currentLanguage) {
            this.publicService.updateBodyDirection(res.lang);
          }
        })
      );
    });
    this.subscriptions.add(
      this.router.events.subscribe((val) => {
        if (val instanceof NavigationEnd) {
          this.activeUrl = val.url;
        }
      })
    );
  }
  ngOnInit(): void {
    this.checkAndRemoveExpiredToken();
    let token = this.userService.getToken();
    if (token) this.userService.setUserLogin(true);
  }
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  checkAndRemoveExpiredToken() {
    const tokenData = this.userService.getExpirationDate();

    if (tokenData) {
      const expirationDate = new Date(tokenData);
      const currentDate = new Date();
      if (currentDate > expirationDate) {
        this.userService.logout();
      }
    }
  }
}
